import { Pipe, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/until-value.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class UntilValuePipe {
    constructor() {
        this.matched = false;
    }
    /**
     * @param {?} value
     * @param {?=} untilValue
     * @return {?}
     */
    transform(value, untilValue) {
        if (this.matched) {
            if (this.matchedValue === untilValue)
                return this.matchedValue;
            this.matched = false;
        }
        if (value === untilValue) {
            this.matched = true;
            this.matchedValue = untilValue;
        }
        return value;
    }
}
UntilValuePipe.ɵfac = function UntilValuePipe_Factory(t) { return new (t || UntilValuePipe)(); };
UntilValuePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "untilValue", type: UntilValuePipe, pure: false });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UntilValuePipe, [{
        type: Pipe,
        args: [{
                name: 'untilValue',
                pure: false
            }]
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    UntilValuePipe.prototype.matched;
    /**
     * @type {?}
     * @private
     */
    UntilValuePipe.prototype.matchedValue;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/until-value.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UntilValueModule {
}
UntilValueModule.ɵfac = function UntilValueModule_Factory(t) { return new (t || UntilValueModule)(); };
UntilValueModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UntilValueModule });
UntilValueModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UntilValueModule, [{
        type: NgModule,
        args: [{
                declarations: [UntilValuePipe],
                imports: [],
                exports: [UntilValuePipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UntilValueModule, { declarations: [UntilValuePipe], exports: [UntilValuePipe] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-until-value.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { UntilValueModule, UntilValuePipe as ɵa };

